/* eslint-disable @typescript-eslint/no-explicit-any */
import { ReactSimpleComponentProps } from '@/custom-types';
import { ErrorHandlerContext, ErrorHandlerProps } from './ErrorHandlerContext';
import { useMemo, useRef, useState } from 'react';

export const ErrorHandlerProvider = ({ children }: ReactSimpleComponentProps) => {
  const errorRef = useRef<any | null>(null)

  const [isOpen, setIsOpen] = useState(false)
  
  const actions = useMemo<Omit<ErrorHandlerProps, 'isOpen' | 'error'>>(() =>({
    open: (error: any) => {
      errorRef.current = error
      setIsOpen(true)
    },

    close: () => {
      errorRef.current = null
      setIsOpen(false)
    }

  }), [])
  
  return (
    <ErrorHandlerContext.Provider value={{ ...actions, isOpen, error: errorRef.current }}>
      {children}
    </ErrorHandlerContext.Provider>
  )
}